<i
  mui-icon
  font="fa"
  class="mui-legacy-btn__icon"
  *ngIf="icon || working"
  [name]="working ? 'spinner-third' : icon"
  [spinning]="working"></i>
<span class="mui-legacy-btn__label">
  <ng-content></ng-content>
</span>
